import { useCountdown } from './hooks/useCountdown';

const ComingSoon = ( {genesisTimestamp } ) => {

  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const monthes = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'];

  const launchDate = new Date('2023-05-01T00:00+00:00');
  const targetDate = new Date(genesisTimestamp*1000)

  const dow = days[launchDate.getDay()];
  const month = monthes[launchDate.getMonth()];
  const day = launchDate.getDate();
  const year = launchDate.getFullYear();
  const hours = launchDate.getHours().toString().padStart(2,'0');
  const minutes = launchDate.getMinutes().toString().padStart(2,'0');
  const monthUTC = launchDate.getUTCMonth() + 1;
  const dayUTC = launchDate.getUTCDate();
  const yearUTC = launchDate.getUTCFullYear();
  const hoursUTC = launchDate.getUTCHours().toString().padStart(2,'0');
  const minutesUTC = launchDate.getUTCMinutes().toString().padStart(2,'0');
  const [remainDays, remainHours, remainMinutes, remainSeconds] = useCountdown(targetDate);

  return (
    <section className="comingSoon">
      <h2>Coming Soon</h2>
      <p className="offer">100 MATIC to win on the first week.</p>
      <p>The lottery will start on {dow}, {month} {day}, {year} at {hours}:{minutes} local time 
      ({monthUTC}/{dayUTC}/{yearUTC} at {hoursUTC}:{minutesUTC} UTC time)</p>
      <p>In the meanwhile, you can make a try on the Mumbai Testnet, the Goerli Testnet or the Sepolia Testnet.</p>
      {
        (remainDays + remainHours + remainMinutes + remainSeconds <= 0) 
        ? <h4 className="time danger">expired</h4>
        : <h4 className={remainDays===0 && hours===0 ? "time danger" : "time"}>
            {remainDays}<span>d</span>
            &nbsp;{remainHours}<span>h</span>
            &nbsp;{remainMinutes}<span>m</span>
            &nbsp;{remainSeconds}<span>s</span>
          </h4>
      }

    </section>
  )

}

export default ComingSoon